// extracted by mini-css-extract-plugin
export default {"root":"style_root__6sOa2","row":"style_row__qs1lG"};